export const MEANINGFUL_ERROR_MESSAGES_MAP = {
  Unauthorized: 'Invalid credentials',
  'No further details': 'Invalid credentials'
} as const

type MessagesKey = keyof typeof MEANINGFUL_ERROR_MESSAGES_MAP

export const makeErrorMessage = (message: string) => {
  const errorMessage = MEANINGFUL_ERROR_MESSAGES_MAP[message as MessagesKey]

  return errorMessage || message
}
